import ICampLite from "~/interfaces/ICampLite"
import { CampingStyleProps, CampProps, SiteProps } from "../interfaces"
import { get } from "./utils/requests"
import { User } from "./types"

const camps = (): Promise<{ camps: ICampLite[] }> => get("/api/me/camps")
const camp = (id: string): Promise<CampProps> => get(`/api/me/camps/${id}`)
const sites_for_camp = (id: string): Promise<SiteProps[]> => get("/api/me/sites", { camp_id: id })
const camping_styles_for_camp = (id: string): Promise<CampingStyleProps[]> =>
  get("/api/me/camping_styles", { camp_id: id })
const fetchMe = (): Promise<User> => get("/api/me")

const Me = {
  camps,
  camp,
  sites_for_camp,
  camping_styles_for_camp,
  fetchMe,
}

export default Me
